export default "__VITE_ASSET__cdULj_L8__"